// import '@mantine/core/styles.css';

import '@mantine/core/styles/global.css';
import '@mantine/core/styles/UnstyledButton.css';
import '@mantine/core/styles/Button.css';
import '@mantine/core/styles/Text.css';
import '@mantine/core/styles/Stack.css';
import '@mantine/core/styles/Container.css';
import '@mantine/core/styles/Grid.css';
import '@mantine/core/styles/Center.css';
import '@mantine/core/styles/Title.css';
import '@mantine/core/styles/Group.css';
import '@mantine/core/styles/Badge.css';
import '@mantine/core/styles/Accordion.css';
import '@mantine/core/styles/Image.css';
import '@mantine/core/styles/Anchor.css';
import '@mantine/core/styles/Divider.css';
import '@mantine/core/styles/Card.css';
import '@mantine/core/styles/Paper.css';
import '@mantine/core/styles/Flex.css';
import '@mantine/core/styles/Switch.css';
import '@mantine/core/styles/Spoiler.css';
import '@mantine/core/styles/Burger.css';

import '../App.css'; // Make sure the file path is correct

import React, { ReactNode, lazy, useEffect } from 'react';
const Footer = lazy(() => import('../components/Footer'))
const NavBar = lazy(() => import('../components/Navbar'))
import { createToast } from '../components/Toast';
import { MessageKind } from '../utils/common';
import { sendErrorToH2E } from '../utils/app';
import { FathomProvider } from '../contexts/FathomContext';
import { Box, createTheme, MantineProvider, Stack } from '@mantine/core';

interface LayoutProps {
    children: ReactNode;
    onlyRequired?: boolean;
    dashboard?: boolean;
    verify_session?: boolean;
    include_navbar?: boolean;
}


const theme = createTheme({
    colors: {
        primary: [
            "#D8E0FB",
            "#cde3ff",
            "#9bc4ff",
            "#66a3fe",
            "#577cff",
            "#1f76fc",
            "#0b6dfd",
            "#005ce2",
            "#0052cb",
            "#0046b4"
        ]
    },
    headings: {
        sizes: {
            h1: {
                fontSize: 'calc(1.425rem + 2.1vw)',
                lineHeight: '1',
            },
            h2: {
                fontSize: 'calc(1.025rem + 0.6vw)',
                lineHeight: '1',
                fontWeight: '300',
            }
        }
    },
    primaryColor: 'primary'
})

const Layout: React.FC<LayoutProps> = ({ children, onlyRequired = false, dashboard = false, verify_session = false, include_navbar = true }) => {
    useEffect(() => {
        // Your function to be triggered after the component is ready
        const urlParams = new URLSearchParams(window.location.search);
        let err = urlParams.get('error_msg');
        if (err !== null) {
            createToast(atob(err), MessageKind.Error);
        }
        let info = urlParams.get('msg');
        if (info !== null) {
            createToast(atob(info), MessageKind.Info);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('error', (ev) => {
            sendErrorToH2E(ev)
        });

        return () => {
            window.removeEventListener('error', sendErrorToH2E);
        };
    }, [])

    return (
        <FathomProvider>
            <MantineProvider theme={theme}>
                <Box bg='gray.0' h='100vh'>
                    <Stack justify='space-between' h='100vh'>
                        <div>
                            {include_navbar && <NavBar verify_session={onlyRequired} />}
                            <main className=''>
                                {children}
                            </main>
                        </div>
                        <Footer onlyRequired={onlyRequired} />
                    </Stack>
                </Box>
            </MantineProvider>
        </FathomProvider>
    );
};

export default Layout;